var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232,
    height: 65,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 62.826 52.05 L 47.63 65.311 c -0.066 0.058 -0.141 0.099 -0.211 0.152 c -0.094 0.072 -0.186 0.144 -0.286 0.207 c -0.118 0.075 -0.241 0.137 -0.365 0.198 c -0.099 0.049 -0.195 0.101 -0.298 0.142 c -0.144 0.057 -0.292 0.097 -0.44 0.137 c -0.093 0.025 -0.181 0.057 -0.277 0.075 c -0.249 0.048 -0.501 0.076 -0.754 0.076 c -0.253 0 -0.505 -0.028 -0.754 -0.076 c -0.095 -0.018 -0.183 -0.05 -0.276 -0.075 c -0.149 -0.04 -0.296 -0.08 -0.441 -0.137 c -0.103 -0.041 -0.199 -0.093 -0.298 -0.142 c -0.124 -0.061 -0.246 -0.123 -0.364 -0.198 c -0.1 -0.064 -0.193 -0.135 -0.287 -0.207 c -0.069 -0.053 -0.144 -0.094 -0.21 -0.152 L 27.174 52.05 c -1.665 -1.452 -1.836 -3.979 -0.384 -5.644 c 1.453 -1.665 3.979 -1.836 5.644 -0.384 L 41 53.498 V 27.704 c 0 -2.209 1.791 -4 4 -4 s 4 1.791 4 4 v 25.794 l 8.566 -7.475 c 1.664 -1.453 4.19 -1.28 5.644 0.384 S 64.491 50.598 62.826 52.05 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(256,256,256)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.17a5e3b13c220db3a883f7bf216b68dc.svg";
export { ForwardRef as ReactComponent };